import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useThunk } from './useThunk';
import { checkSession } from '../store/thunks/user/checkSession';
import { markLoginPending, consumeLoginPending } from '../components/utils/loginHandoff';

const useLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [runCheckSession, isLoadingSession, errorSession] =
    useThunk(checkSession);

  const handleLogin = () => {
    const link_to_switch_login = "https://login.eduid.ch/idp/profile/SAML2/Unsolicited/SSO";
    const providerParam = '?providerId=';
    const https_hostname = encodeURIComponent('https://labex.unil.ch');
    const shibboleth = encodeURIComponent('/shibboleth');
    const providerUrlSection = providerParam + https_hostname + shibboleth;
    const targetParam = '&target=';
    const targetUrlSection = targetParam + https_hostname + getTargetUrl();
    const urlToLogin = link_to_switch_login + providerUrlSection + targetUrlSection;

    markLoginPending();
    window.location.href = urlToLogin;
  };

  const getTargetUrl = () => {
    const prodTarget = encodeURIComponent('/redirect/switcheduprod.php');
    const testTarget = encodeURIComponent('/redirect/switchedutest.php');
    const switchToORSEELocal = encodeURIComponent('/redirect/switchedulocal.php');
    switch (window.location.host) {
      case 'labex.unil.ch':
        return prodTarget;
      case 'experiments-hec.unil.ch':
        return testTarget;
      default:
        return switchToORSEELocal;
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('token');

    if (!token) {
      return;
    }

    // Always strip the token from the address bar, whether or not we accept it,
    // so it does not linger in browser history, referrer headers or server logs.
    urlParams.delete('token');
    const query = urlParams.toString();
    window.history.replaceState(
      null,
      '',
      location.pathname + (query ? `?${query}` : '') + location.hash
    );

    // Only accept a token that arrived from a login this tab actually started.
    if (!consumeLoginPending()) {
      console.warn('Ignoring an unexpected token parameter.');
      return;
    }

    localStorage.setItem('jwtToken', token);
    localStorage.setItem('selectedTab', 0);
    runCheckSession();
    navigate('/orsee');
  }, [navigate, location]);

  return { handleLogin };
};

export default useLogin;
